import { StyleSheet } from 'react-native';
import { themeConfig } from '../../styles/themeConfig';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: themeConfig.colors.background,
    position: 'relative',
  },
  registeredBg: {
    backgroundColor: themeConfig.colors.backgroundRegistered,
  },
  verticalFlex: {
    flexDirection: 'column',
    marginHorizontal: 'auto',
  },
  eventDetails: {
    //paddingTop: 32,
    marginVertical: 0,
    marginHorizontal: 'auto',
  },
  registerTagMD: {},
  registerTagSM: {
    marginTop: 16,
  },
  thumbMDContainer: {
    flex: 4,
    maxWidth: 400,
  },
  thumbImg: {
    width: '100%',
    height: undefined,
    aspectRatio: 4 / 3,
  },
  detailMDContainer: {
    flex: 6,
  },
  paddingHorizontal16: {
    paddingHorizontal: 16,
  },
  title: {
    flexDirection: 'column',
    paddingTop: 24,
    paddingBottom: 8,
    fontSize: 24,
    fontWeight: 'bold',
  },
  desc: {
    paddingVertical: 0,
  },
  viewMoreToggle: {
    paddingVertical: 5,
    fontWeight: 'bold',
    textDecorationLine: 'underline',
  },
  btnContainer: {
    paddingVertical: 20,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  btnItemContainer: {
    width: 40,
    flex: -1,
  },
  btnItem: {
    height: 32,
    width: 32,
    borderRadius: 16,
    flex: 1,
  },
  favIcon: {
    color: themeConfig.colors.white,
  },
  favIconSelected: {
    color: themeConfig.colors.favColor,
  },
  btnRegOrViewTicketContainerMD: {
    paddingVertical: 0,
    paddingHorizontal: 16,
    width: 150,
    flex: 3,
  },
  btnRegOrViewTicketContainerSM: {
    paddingVertical: 0,
    paddingHorizontal: 16,
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },
  card: {
    paddingVertical: 24,
    paddingHorizontal: 16,
    backgroundColor: themeConfig.colors.white,
    borderRadius: themeConfig.settings.borderRadius,
    marginBottom: 10,
  },
  cardMD: {
    marginHorizontal: 0,
    marginTop: 16,
  },
  cardSM: {
    marginTop: 16,
  },
  cardTitle: {
    fontSize: 21,
    fontWeight: '500',
  },
  cardItemContainer: {
    paddingTop: 16,
    flexDirection: 'row',
  },
  cardItemIconContainer: {
    textVerticalAlign: 'top',
    width: 30,
    paddingTop: 5,
    paddingRight: 14,
  },
  cardItemIcon: {
    // ratio
    width: '12',
    // Without height undefined it won't work
    height: undefined,
    // figure out your image aspect ratio
    aspectRatio: 14 / 14,
  },
  cardItemText: {
    fontSize: 14,
    color: themeConfig.colors.black,
  },
  cardSpeakersContainer: {
    paddingTop: 16,
    flexDirection: 'column',
  },
});
